import "./webcontent.css"

const webcontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">What is Web Service?</div>
                <p className="erppara"> 
                Web service is a standardized medium to propagate communication between the client and server applications on the WWW (World Wide Web). A web service is a software module that is designed to perform a certain set of tasks.
                </p>
                <ul className="websub erpul">
	<li className="webpoints">Web services in cloud computing can be searched for over the network and can also be invoked accordingly.</li>
    <li className="webpoints">When invoked, the web service would be able to provide the functionality to the client, which invokes that web service.</li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://www.belcan.com/wp-content/uploads/2022/08/Evolution-of-Engineering-Drawings-600x300.jpg" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default webcontent